import { render, staticRenderFns } from "./upgradePkg.vue?vue&type=template&id=437628a2&scoped=true&"
import script from "./upgradePkg.vue?vue&type=script&lang=js&"
export * from "./upgradePkg.vue?vue&type=script&lang=js&"
import style0 from "./upgradePkg.vue?vue&type=style&index=0&id=437628a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437628a2",
  null
  
)

export default component.exports